export default function Circle() {
    return (<div style={{ border: "0px solid #42A5F566", borderRadius: "50%", backgroundColor:"#42A5F5", marginTop:"7px", width:"8px", height:"8px"}} />)
}